export default function MediaMarquee() {
  const marqueeItems = [
    'ESTRATEGIA',
    'CONTENIDO',
    'RESULTADOS',
    'REPUTACIÓN',
    'POSICIONAMIENTO',
    'INFLUENCIA',
  ];

  const fullList = [...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems];

  return (
    <section id="media-marquee" className="py-4 bg-[#f2f0eb] border-y border-slate-200 overflow-hidden">
      <div className="relative flex overflow-x-hidden">
        <div className="py-1 animate-marquee flex whitespace-nowrap gap-8 items-center">
          {fullList.map((item, index) => (
            <div
              key={index}
              className="inline-flex items-center gap-6 text-slate-500 font-extrabold text-xs tracking-widest uppercase"
            >
              <span className="hover:text-slate-900 transition-colors">{item}</span>
              <span className="w-1.5 h-1.5 rounded-full bg-cyan-600" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
